import {AbstractService} from 'services/AbstractService';

const RELEASE_NOTES_LIST_URL = 'api/releasenotes';

export class ReleaseNotesService extends AbstractService {
  getList (limit = 10, sorting = 'id', clientParams = {}) {
    return this.client.get(RELEASE_NOTES_LIST_URL, {limit, sorting}, {}, {}, clientParams);
  }
}
